export const TRAILER_TYPES = {
    V: 'Van',
    R: 'Refrigerated Carrier (Reefer)',
    F: 'Flatbed',
    TWOF: 'Two 24 or 28 foot Flats',
    ANIM: 'Animal Carrier',
    ANYE: 'Any Equipment',
    AUTO: 'Auto carrier',
    B_TR: 'B-Train/Supertrain',
    BDMP: 'Belly Dump',
    BEAM: 'Beam',
    BELT: 'Conveyor Belt',
    BOAT: 'Boat Hauling Trailer',
    CH: 'Convertible Hopper',
    CONG: 'Conestoga',
    CONT: 'Container Trailer',
    CV: 'Curtain Van',
    DA: 'Drive Away',
    DD: 'Double Drop',
    DDE: 'Double Drop Extendable',
    DUMPT: 'Dump Trucks',
    ENDP: 'End Dump',
    FA: 'FlatBed - Air-Ride',
    FEXT: 'Stretch Trailers or Extendable',
    FINT: 'Flatbed Intermodal',
    FO: 'Flatbed Over-Dimension Loads',
    FSD: 'Flat or Step Deck',
    FSDV: 'Flatbed, Step Deck, or Van',
    FV: 'Van or Flatbed',
    FVR: 'Flatbed, Van, or Reefer',
    FVV: 'Flatbed, Vented Van, or Reefer',
    FWS: 'Flatbed With Sides',
    HOPP: 'Hopper Bottom',
    HS: 'Hot Shot',
    HTOW: 'Haul and Tow Unit',
    LAF: 'Landoll Flatbed',
    LB: 'Lowboy',
    LBO: 'Lowboy over-dimension load',
    LDOT: 'Load-Out are empty trailers you load and haul',
    LIVE: 'Live Bottom Trailer',
    MAXI: 'Maxi or Double Flat Traillers',
    MBHM: 'Mobile Home',
    PNEU: 'Pneumatic',
    PO: 'Power Only (tow-away)',
    RFV: 'Flatbed, Van, or Reefer',
    RGN: 'Removable Goose Neck & Multi-Axle Heavy Haulers',
    RGNE: 'RGN Extendable',
    RINT: 'Refrigerated Intermodal',
    ROLL: 'ROLL Top Conestoga',
    RPD: 'Refrigerated Carrier W/Plant Decking',
    RF: 'Van or Reefer',
    RVF: 'Flatbed, Van, or Reefer',
    SD: 'Step Deck',
    SDE: 'Step Deck Extendable',
    SDL: 'Step Deck w/Loading Ramps',
    SDO: 'Step Deck over-dimension load',
    SDRG: 'Step Deck or RemovableGooseneck',
    SPEC: 'Unspecified Specialized',
    HCV: 'High Cube Van',
    ST: 'Straight Truck',
    TANK: 'Tanker',
    V_OT: 'Open Top Van',
    VA: 'Van - Air-Ride',
    VB: 'Blanket Wrap Van',
    VCAR: 'Cargo Vans (1 Ton capacity)',
    VF: 'Flatbed or Van',
    VFR: 'Flatbed, Van, or Reefer',
    VINT: 'Van Intermodal',
    VIV: 'Vented Insulated Van',
    VIVR: 'Vented Insulated Van or Refrigerated',
    VLG: 'Van w/Liftgate',
    VM: 'Moving Van',
    VR: 'Van or Reefer',
    VRDD: 'Van, Reefer Double Drop',
    VRF: 'Flatbed, Van, or Reefer',
    VV: 'Vented Van',
    VVR: 'Vented Van or Refrigerated',
    WALK: 'Walking Floor Odometer'
}

export const PACKAGING_TYPES = {
    'Palleted': 1,
    'Carton': 2,
    'Crate': 3,
    'Loose / Floor': 4
  };